import React from "react";

import { Helmet } from "react-helmet";
import { partnerType } from "Utils/isPartner";

import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import ThemeInstaller from "Common/ThemeInstaller";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

export default function Chrome({ children, title, headerContent }) {
  const branding = partnerType();

  const renderNavBar = () => {
    const rightContent = [];

    return <ResponsiveTopBar branding={branding} collapseOnSelect={false} rightContent={rightContent} />;
  };
  return (
    <div style={{ backgroundColor: "#ffffff" }}>
      <Helmet titleTemplate="SimplyInsured - %s" title={title} defaultTitle="SimplyInsured" />
      {renderNavBar()}
      {headerContent && (
        <Grid mt={5} p={0}>
          {headerContent}
        </Grid>
      )}
      {children}
      <Footer />
      <ThemeInstaller />
    </div>
  );
}
